// extracted by mini-css-extract-plugin
export default {"errorTable":"error-table_errorTable__e5uP7"};